import React, { useEffect, useState, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { UserContext } from '../contexts/userContext';
import request from '../services/Request';
import EnterEmail from './enterEmail';
import IdleEmail from './items/IdleEmail';

const createOrderURL = `/orders/create`;
const oneTimeStatus = '/promos/status/';

export default function EmailCode(props) {
  const { testMode } = useContext(UserContext);
  const machine = JSON.parse(localStorage.getItem('machine'));
  const currency = machine?.currency?.code;
  const FinalProducts = JSON.parse(localStorage.getItem('FinalProducts'));
  const FinalTax = JSON.parse(localStorage.getItem('FinalTax'));
  const TotalPrice = JSON.parse(localStorage.getItem('TotalPrice'));
  const { receipt, belongTo } = machine;

  const { t } = useTranslation();
  let history = useHistory();
  const machineID = props.id;
  const [show, setShow] = useState(false);
  const [inputShow, setInputShow] = useState(false);
  const [door, setDoor] = useState(t('Your items are vending, please wait.'));
  const [receiptSend, setReceiptSend] = useState(false);
  const [readySend, setReadySend] = useState(false);
  const [orderID, setOrderID] = useState('');
  const [showProduct, setShowProduct] = useState(true);
  const [error, setError] = useState('');
  const [input, setInput] = useState('');
  const [messageWidth, setMessageWidth] = useState('78.4%');
  const [go, setGo] = useState(false);

  let separateItem = JSON.parse(localStorage.getItem('SeparateItem'));
  separateItem = separateItem.filter((e) => e.prodType === 'prod');
  const [pod, setPods] = useState([...separateItem]);

  const cartProds = separateItem.map((prod, i) => {
    // console.log(prod);
    const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    return (
      <div className="payment-product-card" key={i}>
        <img className="card-img" src={url} alt=""></img>
        <div className="payment-card-text">{prod.product_name}</div>
      </div>
    );
  });

  useEffect(() => {
    request({
      method: 'post',
      url: createOrderURL,
      data: {
        machine: machineID,
        products: FinalProducts,
        tax: FinalTax,
        belongTo: belongTo,
        total: TotalPrice,
      },
    }).then((res) => {
      console.log(res.data);
      setOrderID(res.data.order._id);
      setReadySend(true);
    });
  }, []);

  const setKeyBoardShow = () => {
    setInputShow(true);
    setShow(true);
  };

  const submitEmail = () => {
    if (error === '' && input !== '') {
      setShow(false);
      setReceiptSend(true);
    } else {
      const myfocus = document.getElementById('email-enter-input');
      myfocus.focus();
      console.log(myfocus);
    }
    if (input === '') {
      setError(t('Email address can not be empty.'));
    }
  };

  return (
    <div className="main-container">
      <IdleEmail go={go} />
      <div className="payment-container-div">
        {showProduct && (
          <div>
            {/* <img className="payment-logo-img" src={TW_log} alt=""></img> */}
            <div className="payment-products-container">{cartProds}</div>
            <div className="payment-line"></div>
          </div>
        )}

        {receipt !== '' && receipt !== undefined && receipt !== null && inputShow && !receiptSend && (
          <div>
            <div>
              <EnterEmail
                showProduct={showProduct}
                orderID={orderID}
                setReceiptSend={setReceiptSend}
                readySend={readySend}
                inputShow={inputShow}
                id={machineID}
                testMode={props.testMode}
                show={show}
                setShow={setShow}
                setError={setError}
                error={error}
                input={input}
                setInput={setInput}
              />
            </div>
          </div>
        )}
        {inputShow && !receiptSend && (
          <div className="d-flex justify-content-center">
            <div className="view-more-button dispense-get-receipt-button-2" onClick={submitEmail}>
              {t(`GET RECEIPT`)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
